
  // Il tuo codice JS qui
  console.log('Ciao da Shopify!');
  
  document.addEventListener('DOMContentLoaded', function() {
  // Mappa valore -> percorso immagine (modifica i percorsi se necessario)
  var iconMap = {
    'vegan': "https://cdn.shopify.com/s/files/1/0943/1076/0785/files/veganok.png?v=1754296472",
    'riciclo': "https://cdn.shopify.com/s/files/1/0943/1076/0785/files/reciclo.png?v=1754296472",
    '12M': "https://cdn.shopify.com/s/files/1/0943/1076/0785/files/pao.png?v=1754296472",
    '5PP': "https://cdn.shopify.com/s/files/1/0943/1076/0785/files/5PP.png?v=1754296462",
    'istruzioni': "https://cdn.shopify.com/s/files/1/0943/1076/0785/files/istruzioni.png?v=1754296472"
  };

  document.querySelectorAll('.metafield-single_line_text_field').forEach(function(li) {
    var text = li.textContent.trim();
    console.log(text);
    var imgSrc = iconMap[text];
    if(imgSrc){
      li.innerHTML = '<img src="'+imgSrc+'" alt="'+text+'" class="icon_products">';
    }
  });

 /* prendi il primo toggle ed espandilo
  const firstToggle = document.querySelector("toggle-group toggle-tab");

  if(firstToggle) {
    // aggiungi la classe "opened" al toggle
    firstToggle.classList.add("opened");
    // titolo
    const title = firstToggle.querySelector(".toggle__title");
    // contenuto
    const content = firstToggle.querySelector(".toggle__content");

    if(title && content) {
      // forza lo stato "aperto"
      title.setAttribute("aria-expanded", "true");
      content.style.display = "block";
      // se il tuo script usa una classe attiva, aggiungila
      content.classList.add("is-active");
    }
  }
*/

//Sposto il blocco caratterististiche prima del toggle
var richText = document.getElementById("shopify-section-template--25428946616657__rich_text_GQGejc");
var contentToggles = document.getElementById("shopify-section-template--25428946616657__content_toggles_JUd6ch");

if (richText) {
    // seleziona lo span che sta dentro al rich text
    const span = richText.querySelector("span");
    if (span) {
      // aggiungo più classi insieme
      span.classList.add("text-font--body", "text-size--24");
      span.classList.remove("text-size--40");
    }

    const span2 = richText.querySelector(".metafield-rich_text_field");
    if (span2) {
      // aggiungo più classi insieme
      span2.classList.add("text-size--16");
    }
  }



           
              

  /*if (richText && contentToggles) {
    contentToggles.appendChild(richText);
  }*/

  if (richText && contentToggles) {
    var firstToggle = contentToggles.querySelector("toggle-group"); // prende il primo toggle
    if (firstToggle) {
      contentToggles.insertBefore(richText, firstToggle);
    } else {
      // se non trova toggle lo mette comunque dentro
      contentToggles.appendChild(richText);
    }
  }


  //messggio header che cicla ogni 4 secondi
  const messages = document.querySelectorAll('.custom-announcement-bar .message');
  let index = 0;

  setInterval(() => {
    messages[index].classList.remove('active');
    index = (index + 1) % messages.length;
    messages[index].classList.add('active');
  }, 4000); // cambia ogni 4 secondi

});


 
